import globalService from 'Services/api/global.service'
import useSubdomain from 'hooks/useSubdomain/useSubdomain'
import SplashPage from 'pages/SplashPage'
import { useEffect, useState } from 'react'
import getEnv from 'utilities/getEnv'

enum CheckSubdomainStatus {
    Idle,
    Checking,
    Completed,
    Failed,
}

function CheckSubdomainWithTenantProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const { hasSubDomain, subdomain } = useSubdomain()
    const [status, setStatus] = useState<CheckSubdomainStatus>(
        CheckSubdomainStatus.Idle,
    )
    const [failedReason, setFailedReason] = useState<string>('')

    useEffect(() => {
        async function resetCache() {
            if (navigator && navigator.serviceWorker) {
                try {
                    console.log(
                        'query Service Worker registrations to reset...',
                    )
                    const registrations = await navigator.serviceWorker.getRegistrations()

                    // unregister all service workers (to trigger new installation after reloaded)
                    for (const registration of registrations) {
                        await registration.unregister()
                        console.log(`unregistered ${registration.scope}...`)
                    }

                    console.log('reset cache successful!!')
                } catch (err: any) {
                    console.log(err)
                    setStatus(CheckSubdomainStatus.Failed)
                    setFailedReason(
                        `Unable to call serviceWorker API to reset the cache: ${err.message}`,
                    )
                }
            } else {
                setStatus(CheckSubdomainStatus.Failed)
                setFailedReason('No access to serviceWorker API')
            }
        }

        if (hasSubDomain && subdomain) {
            setStatus(CheckSubdomainStatus.Checking)
            globalService
                .getSubdomainInfo(subdomain)
                .then((res) => {
                    console.log({
                        fromApi: res.data.locationTenantIdentifierID,
                        cached: getEnv(
                            'REACT_APP_LOCATION_TENANT_IDENTIFIER_ID',
                        ),
                    })

                    if (
                        getEnv('REACT_APP_LOCATION_TENANT_IDENTIFIER_ID') !==
                        res.data.locationTenantIdentifierID
                    ) {
                        console.log(
                            'CheckSubdomainWithTenantProvider: cached location tenant ID is not matched with the recent id, need to reset the PWA cached',
                        )
                        resetCache().then(() => {
                            // reload the browser
                            window.location.reload()
                        })
                    } else setStatus(CheckSubdomainStatus.Completed)
                })
                .catch((err) => {
                    console.log(
                        'CheckSubdomainWithTenantProvider: error with message ' +
                            err.message,
                    )
                    setFailedReason(
                        'Unable to connect to Cloud API. Please reload the browser.',
                    )
                    setStatus(CheckSubdomainStatus.Failed)
                })
        } else {
            // we do not need to cache PWA for non-subdomain
            resetCache()
        }
    }, [hasSubDomain, subdomain])

    if (hasSubDomain && subdomain) {
        if (
            status === CheckSubdomainStatus.Idle ||
            status === CheckSubdomainStatus.Checking
        )
            return <SplashPage />
        else if (status === CheckSubdomainStatus.Failed)
            return <div>{failedReason}</div>
        else return <>{children}</>
    }

    return <>{children}</>
}

export default CheckSubdomainWithTenantProvider
